export const selectorsCustomer = {
    inputs: {
        // Loan DC
        promiseToPayAmount: '#promise_to_pay_form_amount',
        promiseToPayAmountWrapper: '#promise_to_pay_amount_wrapper',
        promiseToPayMessage: '#display_payday_message',
        promiseToPayDate: '#promise_to_pay_form_date_promise',
        // Client Information Account
        customerPhoneNumber: '#client_information_account_info_update_phoneNumber',
        customerEmail: '#client_information_account_info_update_email',
        clientPinCodeInput: '#client_form_pin_code_input',

        // Client Information Address
        customerAddressInfoAutoComplete: '#client_information_address_update_addressAutocomplete',
        customerAddressInfoStreet: '#client_information_address_update_street',
        customerAddressInfoStreetNumber: '#client_information_address_update_streetNumber',
        customerAddressInfoHouseName: '#client_information_address_update_houseName',
        customerAddressInfoFlatNumber: '#client_information_address_update_flatNumber',
        customerAddressInfoCity: '#client_information_address_update_city',
        customerAddressInfoZipCode: '#client_information_address_update_zipCode',
        customerAddressInfoCounty: '#client_information_address_update_county',
        customerPeopleSplitRent: '#client_information_address_update_peopleSplitRent',

        // Client Information Employment
        customerEmploymentMonthlyIncome: '#client_information_employment_update_monthlyIncome',
        customerEmploymentTotalMonthlyIncome: '#client_information_employment_update_totalMonthlyIncome',
        customerEmploymentRentMortgage: '#client_information_employment_update_rentMortgage',
        customerEmploymentUtilities: '#client_information_employment_update_utilities',
        customerEmploymentLoanPayments: '#client_information_employment_update_loanPayments',
        customerEmploymentOtherPayments: '#client_information_employment_update_otherPayments',
        customerEmploymentTransport: '#client_information_employment_update_transport',
        customerEmploymentOtherHouseholdExpenses: '#client_information_employment_update_otherHouseholdExpenses',
        customerEmploymentFood: '#client_information_employment_update_food',
        customerEmploymentNumberOfDependents: '#client_information_employment_update_numberOfDependents',
        customerEmploymentEmployerName: '#client_information_employment_update_employerName',
        customerEmploymentEmployerPhoneNumber: '#client_information_employment_update_employerPhoneNumber',
        customerEmploymentDateOfDayPaid: '#client_information_employment_update_dateOfDayPaid',

        reducedPlanOwed: '#reduced_payment_plan_step1_form_amount',
        reducedPlanPayment: '#reduced_payment_plan_step1_form_payment_amount',
        reducedPlanInterval: '#reduced_payment_plan_step1_form_payment_interval',
        reducedPlanFirstPayDate: '#reduced_payment_plan_step1_form_first_pay_date',
        reducedPlanDueDate: '#reduced_payment_plan_step1_form_due_date',
        reducedPlanInstallmentCount: '#reduced_payment_plan_step1_form_installment_count',

        reducedPlanIncome: '#reduced_payment_plan_step2_form_income',
        reducedPlanIncomeOther: '#reduced_payment_plan_step2_form_income_other',
        reducedPlanCostHousing: '#reduced_payment_plan_step2_form_cost_housing',
        reducedPlanCostUtils: '#reduced_payment_plan_step2_form_cost_utilities',
        reducedPlanCostCouncil: '#reduced_payment_plan_step2_form_cost_council',
        reducedPlanCostCommitments: '#reduced_payment_plan_step2_form_cost_commitments',
        reducedPlanCostTravel: '#reduced_payment_plan_step2_form_cost_travel',
        reducedPlanCostSubscription: '#reduced_payment_plan_step2_form_cost_subscriptions',
        reducedPlanCostHousehold: '#reduced_payment_plan_step2_form_cost_household',
        reducedPlanCostOther: '#reduced_payment_plan_step2_form_cost_other',
        reducedPlanDependants: '#reduced_payment_plan_step2_form_number_of_dependents',
        // Client Payment
        cardPaymentAmount: '#card_payment_amount',
        cardPaymentPayment: '#card_payment_payment',
        paymentAmount: '#payment_amount_amount',
        // Early Settlement
        earlySettlementOther: '#early_settlement_reason_other',
    },
    checkboxes: {
        cardCpaDisableConfirm: '#card_cpa_disable_disableConfirmation',
        // Client Information Account Info
        customerProcessDataApprove: '#client_information_account_info_update_processDataApprove',
        // Loan sign contract
        contractApprovalReview: '#loan_sign_contract_approval_review',
        contractApprovalPrivacy: '#loan_sign_contract_approval_privacy',
    },
    selects: {
        // Client Information Account Info
        customerTitle: '#client_information_account_info_update_title',
        customerFirstName: '#client_information_account_info_update_name',
        customerLastName: '#client_information_account_info_update_surname',
        customerMaritalStatus: '#client_information_account_info_update_maritalStatus',
        customerDateOfBirth: '#client_information_account_info_update_dateOfBirth',
        customerEmail: '#client_information_account_info_update_email',
        // Client Information Address
        customerHomeOwnerStatus: '#client_information_address_update_homeOwnerStatus',
        customerTimeAtAddress: '#client_information_address_update_timeAtAddress',
        customerTypeOfHousing: '#client_information_address_update_typeOfHousing',
        // Client Information Employment
        customerEmploymentStatus: '#client_information_employment_update_employmentStatus',
        customerEmploymentSalaryPeriodicity: '#client_information_employment_update_salaryPeriodicity',
        customerEmploymentWorkingYears: '#client_information_employment_update_workingYears',
        customerEmploymentNameOfDayPaid: '#client_information_employment_update_nameOfDayPaid',
        // Client Information Vulnerability
        customerVulnerabilityLoanReason: '#client_information_vulnerability_update_loanReason',
        customerVulnerabilityHealthConsiderations: '#client_information_vulnerability_update_healthConsiderations',
        customerVulnerabilityLifeEvents: '#client_information_vulnerability_update_lifeEvents',
        customerVulnerabilityFinancialSupport: '#client_information_vulnerability_update_financialSupport',
        customerVulnerabilityFinancialResilience: '#client_information_vulnerability_update_financialResilience',
        customerVulnerabilityOtherConsiderations: '#client_information_vulnerability_update_otherConsiderations',
        customerVulnerabilityCapabilityIssues: '#client_information_vulnerability_update_capabilityIssues',
        customerVulnerabilityFinancialKnowledgeSupport: '#client_information_vulnerability_update_financialKnowledgeSupport',
        customerVulnerabilityPriorityBillsUpToDate: '#client_information_vulnerability_update_priorityBillsUpToDate',
        // Contract RL
        customerContractForm: 'form[name="loan_sign_contract"]',
        // Early Settlement
        earlySettlementReason: '#early_settlement_reason_reason',
    },
    submits: {
        promiseToPay: '#promise_to_pay_form_save',
        cardCpaDisable: '#card_cpa_disable_save',
        // Client Information Account Info
        accountInfoUpdateSubmit: '#client_information_account_info_update_save',
        // Client Information Address
        addressUpdateSubmit: '#client_information_address_update_save',
        // Client Information Employment
        employmentUpdateSubmit: '#client_information_employment_update_save',
        // Client Information Vulnerability
        vulnerabilityUpdateSubmit: '#client_information_vulnerability_update_save',
        reducedPlanStep1: '#reduced_payment_plan_step1_form_save',
        reducedPlanStep2: '#reduced_payment_plan_step2_form_save',
        // Client Payment
        cardPaymentAmount: '#card_payment_continue',
        cardPaymentPay: '#card_payment_pay',
        paymentAmount: '#payment_amount_save',
        // Early Settlement
        earlySettlementReason: '#early_settlement_reason_confirm',
        // Contract RL
        contractSubmit: '#loan_sign_contract_save',
    },
    blocks: {
        reducedPlanInstallments: '#reduced_plan_installments_container',
        customerHomeOwnerStatusConditional: '#customerHomeOwnerStatusConditional',
    },
}
